import { z } from 'zod';
/**
 * Thèmes (designs) de la régie, lot C. Un thème est une identité visuelle —
 * navigation, typographie, palette —, indépendante du mode clair/sombre et du
 * mode foire, qui restent au choix de chaque utilisateur.
 *
 * Le thème d'une galerie se règle dans la console (`console:manage-appearance`) ;
 * `choixThemeClient` dit si ses utilisateurs peuvent en choisir un autre. La
 * régie lit les deux dans la session.
 */
export const THEMES_REGIE = [
    'halo',
    'structure',
    'collection',
    'brut',
    'atelier',
    'aurore',
    'monolithe',
    'blanc',
    'spatial',
    'chrome',
    'liquid-glass',
    'verre-de-jour',
    'verre-de-nuit',
];
/** Le thème des galeries existantes et des galeries neuves. */
export const THEME_REGIE_DEFAUT = 'halo';
export const themeRegieSchema = z.enum(THEMES_REGIE);
export function estThemeRegie(valeur) {
    return typeof valeur === 'string' && THEMES_REGIE.includes(valeur);
}
//# sourceMappingURL=themes.js.map